import { useMemo } from 'react'

import { formatDateQuery, getYear } from '@scouts/helpers'

import {
    getQuarterDateInterval,
    getQuarterNumber,
    quarterOfTheYear,
    PREVIOUS_QUARTER,
} from '@/domain/quarterly-tax-return'

const FILTER_CURRENT_YEAR = 'CurrentYear'
const FILTER_PREVIOUS_YEAR = 'PreviousYear'
const FILTER_CURRENT_QUARTER = 'CurrentQuarter'
const FILTER_QUARTER = 'Quarter'

const CURRENT_YEAR = getYear()
const CURRENT_QUARTER = quarterOfTheYear() as keyof typeof PREVIOUS_QUARTER

const currentQuarterNumber = getQuarterNumber()

const { start: currentQuarterStart, end: currentQuarterEnd } = getQuarterDateInterval(CURRENT_YEAR, CURRENT_QUARTER)

const getPreviousQuarters = () => {
    const previousQuarters = []
    const isCurrentQuarterQ1 = currentQuarterNumber === 1

    if (isCurrentQuarterQ1) {
        const { start: currentQuarterStart, end: currentQuarterEnd } = getQuarterDateInterval(CURRENT_YEAR - 1, `Q4`)

        previousQuarters.push({
            startDate: formatDateQuery(currentQuarterStart),
            endDate: formatDateQuery(currentQuarterEnd),
            label: `Trimestre 4 - Año ${CURRENT_YEAR - 1}`,
            key: `${FILTER_QUARTER}4`,
        })
    }

    for (let i = currentQuarterNumber - 1; i > 0; i--) {
        const { start: currentQuarterStart, end: currentQuarterEnd } = getQuarterDateInterval(CURRENT_YEAR, `Q${i}`)

        previousQuarters.push({
            startDate: formatDateQuery(currentQuarterStart),
            endDate: formatDateQuery(currentQuarterEnd),
            label: `Trimestre ${i}`,
            key: `${FILTER_QUARTER}${i}`,
        })
    }

    return previousQuarters
}

export const useFilters = () => {
    const filters = useMemo(() => {
        const previousQuarters = getPreviousQuarters()

        return [
            {
                startDate: formatDateQuery(currentQuarterStart),
                endDate: formatDateQuery(currentQuarterEnd),
                label: `Trimestre ${currentQuarterNumber}`,
                key: FILTER_CURRENT_QUARTER,
            },
            ...previousQuarters,
            {
                startDate: formatDateQuery(`${CURRENT_YEAR}-01-01`),
                endDate: formatDateQuery(`${CURRENT_YEAR}-12-31`),
                label: `Año ${CURRENT_YEAR}`,
                key: FILTER_CURRENT_YEAR,
            },
            {
                startDate: formatDateQuery(`${CURRENT_YEAR - 1}-01-01`),
                endDate: formatDateQuery(`${CURRENT_YEAR - 1}-12-31`),
                label: `Año ${CURRENT_YEAR - 1}`,
                key: FILTER_PREVIOUS_YEAR,
            },
        ]
    }, [])

    return { filters }
}
